import { Chord } from 'tonal';

export const isValidChords = (chords: string[]): boolean => {
	return chords.every((chord) => {
		if (chord?.includes('/')) {
			const [root, bass] = chord.split('/');

			const rootData = Chord.get(root);
			const bassData = Chord.get(bass);

			return !rootData?.empty && !bassData?.empty;
		}

		const chordData = Chord.get(chord);

		return !chordData?.empty;
	});
};
